export interface VoiceProfilePillsProps {
  selectedProfileId?: number;
  isFullScreen?: boolean;
  onProfileSelected(id: number): void;
}

export const MAX_VISIBLE_PILLS = 2;
export const MAX_VISIBLE_PILLS_FULL_SCREEN = 3;
export const VOICE_PROFILES_DROPDOWN_LEFT_OFFSET = 82;
export const VOICE_PROFILES_MODAL_HEIGHT = '356px';
